import React, { useState } from 'react';
import classNames from 'classnames';

const VerticalPositionSettings = (props) => {
  const defaultValue = "center center"
  const vertical = (props.position.value || defaultValue).split(' ')[1];
  const isActive = (val) => val === vertical;

  const optionClasses = (val) => {
    return classNames(
      'btn btn-form',
      { 'active': isActive(val) }
    );
  };
  const handleChange = (val) => {
    const { onChange, position: { field } } = props;
    const horizontal = (props.position.value || defaultValue).split(' ')[0];
    const newValue = [horizontal, val].join(' ');
    onChange(field, newValue);
  };
  const options = ['top', 'center', 'bottom'];
  const renderOption = (value, index) => (
    <button
      className={optionClasses(value)}
      onClick={() => handleChange(value)}
      key={`position-y--${index}`}
    >
      <div className={`fi fi-va-${value}`}></div>
    </button>
  );
  return (
    <div className="form-group">
      <label>{ i18n.t('vertical_position') }</label>
      <div className="btn-group">
        {options.map(renderOption)}
      </div>
    </div>
  );
};

export default VerticalPositionSettings;
